import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import { GameType, WithMeta } from '@ygoargentina/sdk/api/api.types';

export const listGameTypes = async () =>
  getGraphQLQueryClient(null).request<WithMeta<GameType>>(gql`
    query {
      data: gameTypes {
        data {
          id
          name
        }
      }
    }
  `);
